/**
 * The in-app path a guard stashed in router state as `{ from }`, or null.
 *
 * Only a same-origin absolute path is honoured. A value like `//evil.example` or `https://...` in
 * history state must never become a redirect target, so anything that is not `/something` (and
 * not protocol-relative) is ignored.
 */
export const returnPathFrom = (state: unknown): string | null => {
  const from = (state as { from?: unknown } | null)?.from;
  if (typeof from !== 'string') return null;
  if (!from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) return null;
  if (from === '/login') return null;
  return from;
};
